module.exports = __webpack_public_path__ + "img/2.9ee0a5db.png";